/* global localData */
if (document.querySelector('.sc-single-task .answer-box__footer-left button')) {
  const submitButton = document.querySelector('.sc-single-task .answer-box__footer-left button');
  const textArea = document.querySelector('.sc-single-task form textarea');
  submitButton.addEventListener('click', (item) => {
    item.preventDefault();
    if (textArea.value) {
      const ajax = new XMLHttpRequest();
      const formInfo = new FormData();
      formInfo.append('action', 'saveUserTaskAnswer');
      formInfo.append('nonce', localData.nonce);
      formInfo.append('id', localData.id);
      formInfo.append('text', textArea.value);
      ajax.open('POST', localData.siteURL, true);
      ajax.onload = () => {
        const response = JSON.parse(ajax.responseText);
        const answerBox = document.querySelector('.answer-box');
        answerBox.classList.remove('answer-box--correct');
        answerBox.classList.remove('answer-box--incorrect');
        answerBox.classList.add(response.class);
        answerBox.querySelector('.answer-box__attempts p').innerHTML = response.attempts;
        answerBox.querySelector('.answer-box__result--correct p').innerHTML = response.message;
        answerBox.querySelector('.answer-box__result--incorrect p').innerHTML = response.message;
      };
      ajax.send(formInfo);
    }
  });
}
